import "./namespace.js";

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};

Sparkle.Embed.Events = {
  // Triggered when an embedded component has loaded. Should be triggered on the component container.
  componentReady: function (componentContainer) {
    // Use vanilla JS for these because in pagebuilder they are listened for across an Iframe, and jQuery doesn't
    // let us listen for an event in one window that is triggered by a different instance of jQuery.
    jQuery(componentContainer)[0].dispatchEvent(new Event("sparkle:componentready", { bubbles: true }));
  },

  onComponentReady: function (element, handler) {
    element.addEventListener("sparkle:componentready", handler);
  },
};
